import React, { useState, useEffect } from 'react';
import DetailLayout from '../../layout/Detail';
import { getUserVideoProgress } from '../../utils/localCache.util';
import { Link, useParams } from 'react-router-dom';
import TopMenu from '../common/TopMenu';
import { ArrowLeftIcon, PlayIcon } from '@heroicons/react/16/solid';
import BgPlayer from '../common/BgPlayer';

const PpcDetailsPage = ({
    detailPageData: initialDetailPageData,
    handleHideDetailPage,
    videos,
    containerIdPrefix,
    setShowDetailPage,
    activePage: initialActivePage,
    activeSubPage: initialActiveSubPage,
    menuData,
    handlePageChange,
    activePageLayoutType,
}) => {
    const { videoTitle } = useParams();
    const [detailPageData, setDetailPageData] = useState(initialDetailPageData);
    const [showButtons, setShowButtons] = useState(false);
    const [currentProgress, setCurrentProgress] = useState(0);
    const [activePage, setActivePage] = useState(initialActivePage);

    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem('detailPageData')) || {};
        const videoData = storedData.videos?.find(
            (video) => video.title.replace(/\s+/g, '_').toLowerCase() === videoTitle
        );
        const playlistId = window.location.pathname.split('/')[2];
        // const playlistCategoryId = window.location.pathname.split('/')[3];
        setActivePage(playlistId);

        if (videoData) {
            setDetailPageData((prevData) => ({
                ...prevData,
                ...videoData,
            }));
        }
    }, [videoTitle]);

    useEffect(() => {
        const myProgress = getUserVideoProgress(detailPageData.id);
        if (myProgress > 0) {
            setCurrentProgress(Math.ceil(Number(myProgress)));
        } else {
            setCurrentProgress(0);
        }
        setShowButtons(true);
    }, [detailPageData.id]);

    useEffect(() => {
        const combinedData = { detailPageData, videos, containerIdPrefix, activePage };
        localStorage.setItem('detailPageData', JSON.stringify(combinedData));
    }, [detailPageData, videos, containerIdPrefix, activePage]);


    const handleScroll = () => {
        const focusedElements = window.document.querySelectorAll('.prj-element.focused');
        if (focusedElements.length > 0) {
            if (focusedElements[0].id === 'resume-btn') {
            } else if (detailPageData.isPortrait === true) {
                window.document.querySelectorAll('.video-details')[0].style.marginTop = `195px`;
            } else if (detailPageData.isPortrait === false) {
                window.document.querySelectorAll('.video-details')[0].style.marginTop = `239px`;
            }
        }
    };

    function formatDuration(seconds) {
        const hrs = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const formattedHours = hrs > 0 ? `${hrs.toString().padStart(2, '0')}h` : '';
        const formattedMinutes = mins > 0 ? `${mins.toString().padStart(2, '0')}m` : '';
        return `${formattedHours} ${formattedMinutes}`.trim();
    }
    const formattedTime = formatDuration(detailPageData.duration);

    const handlePlayerUrlType = (event) => {
        const className = event.currentTarget.className;
        if (className.includes('ppc_watch_now_button')) {
            document.cookie = "video_content_type=watch_now; path=/; max-age=" + 60 * 60 * 24;
        } else if (className.includes('ppc_trailer_btn')) {
            document.cookie = "video_content_type=trailer; path=/; max-age=" + 60 * 60 * 24;
        }
    };

    const clickOnBackButton = () => {
        window.history.back(); 
    };

    return (
        <DetailLayout>
            <>
            <TopMenu
                menuData={menuData}
                activePage={activePage}
                handlePageChange={handlePageChange}
                activePageLayoutType={activePageLayoutType}
            />

            <div className='main-cont'>
                { detailPageData.background_image_video === "Video" ? (
                    <>
                        <BgPlayer id="bg-player" source={detailPageData.background_video_url} />
                        <div className={`${detailPageData.ppc_dark_overlay === true ? "ppc-bg-poster ppc-bg-overlay" : "ppc-bg-poster"}`} />
                    </>
                ) : (
                    <>
                        <div className={`${detailPageData.ppc_dark_overlay === true ? "ppc-bg-poster ppc-bg-overlay" : "ppc-bg-poster"}`} style={{ backgroundImage: `url("${detailPageData.ppc_background_image || detailPageData.posterH}")` }} />
                        <button type="button" className="hide" id="video-detail-focus" onClick={handleScroll}>
                            Scroll
                        </button>
                    </>
                )}

                <div className={ detailPageData.isPortrait ? 'video-details-main-div movies' : 'video-details-main-div videos'} id="video-detail-focus" >
                    <div className="back-to-page prj-element" id="back-to-page" onClick={() => sessionStorage.removeItem('initialUrl')}>
                        <ArrowLeftIcon className="" onClick={clickOnBackButton} />
                    </div>

                    <div className="video-details">
                        <div className="details ppc_video_details">
                            <div className="ppc_title">{detailPageData.title}</div>
                            <div className="flex-box">
                                {detailPageData.releaseDate && (
                                    <span className="video-details-release-date ppc_bold">
                                        {detailPageData.releaseDate.split('-')[0]}
                                    </span>
                                )}
                                <span className='ppc_span_release_data'></span>
                                {detailPageData.duration && (
                                    <>
                                        {detailPageData.releaseDate && (
                                            <span className="video-details-duration ppc_bold">
                                                {formattedTime}
                                            </span>
                                        )}
                                    </>
                                )}

                                {detailPageData.rating && (
                                    <div className="video-rating ppc_bold">
                                        <li>{detailPageData.rating}</li>
                                    </div>
                                )}
                            </div>
                            <div className="description ppc_bold">{detailPageData.shortDescription}</div>
                            {showButtons && (
                                <div className="buttons">
                                    <Link
                                        to={`/watch/featured/${detailPageData.title.toLowerCase().replace(/\s+/g, '_')}`}
                                        id="play-btn"
                                        type="button"
                                        className={
                                            currentProgress === 0
                                                ? 'play-btn small prj-element ppc_watch_now_button '
                                                : 'play-btn prj-element beginning-btn ppc_watch_now_button'
                                        }
                                        data-focus-left="#resume-btn"
                                        data-focus-right={false}
                                        data-focus-up={false}
                                        data-focus-down=".video.prj-element"
                                        data-on-self-focus="#video-detail-focus"
                                        onClick={handlePlayerUrlType}
                                    >
                                        <PlayIcon className='size-6 ppc_play_svg' />
                                        Watch Now
                                    </Link>

                                    {detailPageData.ppc_trailer_url && (
                                        <Link
                                        to={`/watch/featured/${detailPageData.title.toLowerCase().replace(/\s+/g, '_')}`}
                                            id="play-btn"
                                            type="button"
                                            className={
                                                currentProgress === 0
                                                    ? 'play-btn small prj-element ppc_trailer_btn '
                                                    : 'play-btn prj-element beginning-btn ppc_trailer_btn'
                                            }
                                            data-focus-left="#resume-btn"
                                            data-focus-right={false}
                                            data-focus-up={false}
                                            data-focus-down=".video.prj-element"
                                            data-on-self-focus="#video-detail-focus"
                                            onClick={handlePlayerUrlType}
                                        >
                                            Trailer
                                        </Link>
                                    )}
                                </div>
                            )}
                            <div className="description ppc_bold">{detailPageData.description}</div>
                        </div>
                    </div>
                </div>
            </div>
            </>
        </DetailLayout>
    )
}

export default PpcDetailsPage